import React from "react";

// Per-agent status chip for a Trusted-Agent search request — the A6·a extended
// chip family (Commissioned Search, Annex A6·a): the same pill pattern as the V3
// axis (Accepted/Declined/Sent), grown with the commission-lifecycle states
// Searching, Delivered · N, Nothing found, Closed, Expired, Pending and Seen.
// One pill look for all; nothing shrinks or truncates — long labels wrap with
// the row (translation-safety rule, TRANSLATIONS §3).
//
// "Delivered · N" carries the proposal count: pass `count` and the chip renders
// "Delivered · 3"; a null/undefined count renders a bare "Delivered" (never a
// misleading "· 0" — the honest empty path is its OWN `nothing_found` chip).
const CONFIG = {
  sent: { label: "Sent", className: "bg-[#F3F4F6] text-[#6B7280]" },
  // A14 pending/seen — the invitation is out but untouched (Pending) or opened
  // by the agent (Seen). Seen leans blue to read as "movement", Pending neutral.
  pending: { label: "Pending", className: "bg-[#F3F4F6] text-[#6B7280]" },
  seen: { label: "Seen", className: "bg-[#EEF2FF] text-[#4F46E5]" },
  accepted: { label: "Accepted", className: "bg-[#ECFDF5] text-[#16A34A]" },
  // The live commission — the agent's request is up in the network.
  searching: { label: "Searching", className: "bg-[#E8F1FF] text-[#2283FF]" },
  // Result states.
  delivered: { label: "Delivered", className: "bg-[#ECFDF5] text-[#16A34A]" },
  nothing_found: { label: "Nothing found", className: "bg-[#FEF3C7] text-[#B45309]" },
  declined: { label: "Declined", className: "bg-[#FEE2E2] text-[#DC2626]" },
  expired: { label: "Expired", className: "bg-[#F3F4F6] text-[#9CA3AF]" },
  new: { label: "New", className: "bg-[#E8F1FF] text-[#2283FF]" },
  // W1-07 / QA N-G1: the request itself was closed by the club — shown on the
  // agent inbox (Archived rows + closed marker on resolved rows).
  closed: { label: "Closed", className: "bg-[#F3F4F6] text-[#6B7280]" },
};

const SearchRequestStatusChip = ({ status, count, className = "" }) => {
  const cfg = CONFIG[status] || CONFIG.sent;
  // A1/A15 "Delivered · N": only when a real count travels (0 stays a bare
  // "Delivered" here — the empty path renders as `nothing_found`, not "· 0").
  const label =
    status === "delivered" && count != null && count > 0
      ? `${cfg.label} · ${count}`
      : cfg.label;
  return (
    <span
      className={`inline-block text-[10.5px] font-semibold px-2 py-0.5 rounded-full ${cfg.className} ${className}`}
    >
      {label}
    </span>
  );
};

export default SearchRequestStatusChip;
